import { render, staticRenderFns } from "./ImportBenefitCodes.vue?vue&type=template&id=0f40e57f&scoped=true&"
import script from "./ImportBenefitCodes.vue?vue&type=script&lang=js&"
export * from "./ImportBenefitCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f40e57f",
  null
  
)

export default component.exports